import { observable } from 'mobx';

class SalesStore {
  @observable offers = [];

  @observable showableSalesOfferAlert = false;

  @observable showableDashboardOfferAlert = false;

  @observable campaigns = {
    loading: true,
    error: false,
    list: {},
    ids: [],
    numberOfSales: {}
  };
}

export default new SalesStore();
